import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  addWishlist,
  addWishlistFailed,
  addWishlistSuccess,
  deleteWishlist,
  deleteWishlistFailed,
  deleteWishlistSuccess,
  getWishlist,
  getWishlistFailed,
  getWishlistSuccess,
} from "./slice";

//--------------------addWishlistSaga-------------------------

function* addWishlistSaga(action: ReturnType<typeof addWishlist>): any {
  try {
    const { carId } = action.payload;
    const response = yield call(request.post, endpoints.addToWishlist, {
      carId: Number(carId),
    });
    yield put(addWishlistSuccess(response));
  } catch (error: any) {
    yield put(addWishlistFailed(error));
  }
}

//--------------------getWishlistSaga-------------------------

function* getWishlistSaga(action: ReturnType<typeof getWishlist>): any {
  try {
    const { page = 1, limit = 10 } = action.payload;
    const response = yield call(
      request.get,
      `${endpoints.getWishlist}?page=${page}&limit=${limit}`
    );
    yield put(getWishlistSuccess(response));
  } catch (error: any) {
    yield put(getWishlistFailed(error));
  }
}

//--------------------deleteWishlistSaga-------------------------

function* deleteWishlistSaga(action: ReturnType<typeof deleteWishlist>): any {
  try {
    const { carId } = action.payload;
    const response = yield call(
      request.delete,
      `${endpoints.deleteWishlist}/${Number(carId)}`
    );
    yield put(deleteWishlistSuccess(response));
  } catch (error: any) {
    yield put(deleteWishlistFailed(error));
  }
}

function* wishlistSagas() {
  yield all([
    takeLatest(addWishlist, addWishlistSaga),
    takeLatest(getWishlist, getWishlistSaga),
    takeLatest(deleteWishlist, deleteWishlistSaga),
  ]);
}

export { wishlistSagas };
